var app = angular.module("leonardo");

var OnDemandWarningDialog = function($scope, OnDemandInstructionService) {
  $scope.emails = 0;
  $scope.instruction = $scope.ngDialogData.instruction;
  $scope.create = $scope.ngDialogData.create;

  if ($scope.ngDialogData.notify) {
    var params = angular.copy($scope.instruction);
    if ($scope.create) {
      params.create = true;
    }
    OnDemandInstructionService.getEmails(params).then(function(result) {
      $scope.emails = result.number_of_accounts;
    });
  }

};

app.controller('OnDemandWarningDialog', ['$scope', 'OnDemandInstructionService', OnDemandWarningDialog]);
